// TermInfoList.js
import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Box } from '@mui/system';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import PhonelinkRingIcon from '@mui/icons-material/PhonelinkRing';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import SettingsIcon from '@mui/icons-material/Settings';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import FlawedList from '../message/FlawedList';
import FlexyTable from '../common/flexytable/FlexyTable';
import ValueUtil from '../../model/ValueUtil';
import { AppPalette, AppWord } from '../../model/AppConst';
import { TermInfoTableColumns as TableColumns } from './TermInfoGql';
import { ContentHeader, HeaderLeft, HeaderRight } from '../common/CvoStyled';
import SearchBox from '../common/SearchBox';
const LocalTitle = '단말기정보';

const TermInfoListContainer = styled(Box)({
    flex:1,
    display:"flex", flexDirection:'column'
});

export default function TermInfoList({
	maxHeight,
	maxWidth,
	selected,
    onClickItem,
    onRequestAdd,
    onRequestAddSmartLogis,
    onRequestEdit,
    onRequestRemove,
    onRequestSetState,
    isAdminMode,
    isListMode,
    responseList,
    responseRemove,
    onRequestReload,
    customerNotAlive = false,
}) {
    const [filterCriteria, setFilterCriteria] = useState(null);
    const [search, setSearch] = useState('');
    const [itemSelected, setItemSelected] = useState(selected);
    const {loading:loadingList, error:errorOfList, data:dataList} = responseList;

    const onChangeSearch = (text) => {
        setSearch(text);
    };

    const onClickToolOnRow = (toolId, row, event) => {
        switch(toolId) {
            case AppWord.CMD_REMOVE: onRequestRemove(row, event); break;
            case AppWord.CMD_EDIT: onRequestEdit(row, event); break;
            case AppWord.CMD_SETTING: onRequestSetState(row, event); break;
            default: return;
        }
    };

    const onSelectItem = (item) => {
        setItemSelected(item);
		if(onClickItem) onClickItem(item);
    };

    // Handling list event
    if(ValueUtil.flawedListResponse(responseList))
        return <FlawedList title={LocalTitle} gqlResponse={responseList} />;

    return(
        <TermInfoListContainer>
            <ContentHeader>
                <HeaderLeft>
                    <SearchBox
                        value={search}
                        onChange={onChangeSearch}
                        disabled={loadingList}
                    />
                </HeaderLeft>
                <HeaderRight>
                    <Button
                        variant='contained' color='info'
                        onClick={onRequestAddSmartLogis}
                        disabled={customerNotAlive}
                    >
                        <PhonelinkRingIcon />
                        신규 스마트폰
                    </Button>
                    {
                        isAdminMode ?
                        <Button style={{marginLeft:10}}
                            onClick={onRequestAdd}
                            disabled={customerNotAlive}
                            variant='contained' color='primary'>
                            <AddIcon fontSize='small' />
                            단말기 추가
                        </Button>
                        : null
                    }
                </HeaderRight>
            </ContentHeader>

            <FlexyTable
                name="term_info_list"
                uniqueKey="devId"
                columns={TableColumns}
                records={dataList.termInfoList}
                search={search}
                criteria={filterCriteria}
                tools={isAdminMode ? [
                    {id:AppWord.CMD_SETTING, icon: <SettingsIcon fontSize={AppWord.SMALL} />, title: '상태 변경 하기'},
                    {id:AppWord.CMD_EDIT, icon:<NoteAltIcon fontSize={AppWord.SMALL}  color={AppPalette.PrimaryColor} />},
                    {id:AppWord.CMD_REMOVE, icon: <DeleteForeverIcon fontSize={AppWord.SMALL}  color={AppPalette.SecondaryColor} />}
                ] : undefined}
                onClickTool={isAdminMode ? onClickToolOnRow : undefined}
				onClickOneRow={onSelectItem}
				selected={selected ? [selected] : null}
                onRequestReload={onRequestReload}
            />
        </TermInfoListContainer>
    );

}
